module.exports = __webpack_public_path__ + "static/media/national-broadband-ireland.4ef8bea5.png";